import { render } from "./Sms.vue?vue&type=template&id=f44d89da&scoped=true"
import script from "./Sms.vue?vue&type=script&lang=js"
export * from "./Sms.vue?vue&type=script&lang=js"

import "./Sms.vue?vue&type=style&index=0&id=f44d89da&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f44d89da"]])

export default __exports__